import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import apiPath from "../constants/apiPath";

const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "AKIAFBC97UM4I3ILWTIKQ",
    secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
  },
  endpoint: "https://s3-noi.aces3.ai/",
  forcePathStyle: true,
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
};

const s3Client = new S3Client(s3Config);

export const uploadToS3 = async ({ file, type = "images" }) => {
  const key = "sojo/" + type + `/${file.name}`;

  const params = {
    Bucket: "invent-co-new",
    Key: key,
    Body: file,
    ContentType: file.type,
  };

  const upload = new Upload({
    client: s3Client,
    params: params,
  });

  try {
    const data = await upload.done();

    const response = {
      location: apiPath.assetURL + data.Key,
    };
    console.log(data, response);
    return response;
  } catch (err) {
    throw err;
  }
};
